
// Wed Jul 08 2015
export const formattedDate = (dateString?: string) => {
    if (dateString === undefined || dateString == null || dateString === "") { return "" }
    const date = new Date(dateString)
    return date.toDateString()
}